import React, { useEffect, useState } from 'react';
import { defaultAxiosInstance } from '../api/defaultInstance';
import { FaStar, FaRegStar } from 'react-icons/fa';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import '../css/AdProductManagement.css';

function NewsReleaseCategoryManagement() {
    const [categories, setCategories] = useState([]);
    const [filter, setFilter] = useState({
        categoryName: '',
        page: 1,
        limit: 20
    });
    const [totalCount, setTotalCount] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await defaultAxiosInstance.get('/advertisement/admin/newsRelease/categories');
            if (response.data?.data) {
                setCategories(response.data.data);
                setTotalCount(response.data.data.length);
            } else {
                setCategories([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error('카테고리 조회 오류', error);
            setCategories([]);
            setTotalCount(0);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => ({ ...prev, [name]: value }));
    };

    const filteredCategories = categories.filter(category => 
        filter.categoryName === '' || category.name === filter.categoryName
    );

    const handleStarClick = async (category, e) => {
        e.stopPropagation();
        const newRecommended = !category.isRecommended;

        try {
            await defaultAxiosInstance.put(`/advertisement/admin/newsRelease/recommend/toggle/${category.categoryId}`, {
                isRecommended: newRecommended
            });
            setCategories(prevCategories => 
                prevCategories.map(c =>
                    c.categoryId === category.categoryId
                        ? { ...c, isRecommended: newRecommended }
                        : c
                )
            );
        } catch (error) {
            console.error("추천 설정 오류", error);
        }
    };

    const handleRowClick = (category) => {
        navigate(`/ads/newsRelease/category/detail?categoryId=${category.categoryId}`, { state: { category } });
    };

    const handleRegisterClick = () => {
        navigate('/ads/newsRelease/category/write');
    };

    return (
        <Layout>
            <div className="ad-product-management-container">
                {/* 필터 영역 */}
                <div className="filter-bar-2">
                    <div className="filter-group">
                        <label>카테고리</label>
                        <select
                            name="categoryName"
                            onChange={handleFilterChange}
                            value={filter.categoryName}
                        >
                            <option value="">전체</option>
                            {categories.map(category => (
                                <option key={category.categoryId} value={category.name}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* 헤더 영역 */}
                <div className="table-header">
                    <h3 className="section-title">언론배포 카테고리 관리</h3>
                    <div className="button-group">
                        <button type="button" className="register-btn" onClick={handleRegisterClick}>
                            카테고리 등록하기
                        </button>
                    </div>
                </div>

                {/* 카테고리 테이블 */}
                <div className="ad-product-table">
                    <table>
                        <thead>
                            <tr>
                                <th>카테고리명</th>
                                <th>카테고리 설명</th>
                                <th>라벨</th>
                                <th>초기 가격</th>
                                <th>추천</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredCategories.map(category => (
                                <tr key={category.categoryId} onClick={() => handleRowClick(category)} style={{ cursor: 'pointer' }}>
                                    <td>{category.name}</td>
                                    <td>{category.description}</td>
                                    <td>{category.labels?.join(', ') || ''}</td>
                                    <td>{category.startPrice?.toLocaleString() || 0}원</td>
                                    <td style={{ cursor: 'pointer' }}>
                                        {category.isRecommended ? (
                                            <FaStar
                                                style={{ color: 'gold' }}
                                                onClick={(e) => handleStarClick(category, e)}
                                            />
                                        ) : (
                                            <FaRegStar
                                                style={{ color: 'gold' }}
                                                onClick={(e) => handleStarClick(category, e)}
                                            />
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* 페이징 영역 */}
                <div className="pagination-info">
                    <div>
                        총 {totalCount}개 항목
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default NewsReleaseCategoryManagement; 